export enum AuthModalState {
  SHOW_SIGN_IN = 'SHOW_SIGN_IN',
  SHOW_SIGN_UP = 'SHOW_SIGN_UP',
  SHOW_PENDING_VERIFICATION = 'SHOW_PENDING_VERIFICATION',
  SHOW_2FA = 'SHOW_2FA',
  SHOW_FORGOT_PASSWORD = 'SHOW_FORGOT_PASSWORD',
}

export const enum EventTypes {
  LoggedIn = 'USER_LOGGED_IN',
  LoggedOut = 'USER_LOGGED_OUT',
  UserVerified = 'USER_VERIFIED',
  UserOnboarded = 'USER_ONBOARDED',
  RefetchLogin = 'REFETCH_LOGIN',
}

export const TRACK_EVENT_NAMES: Record<AuthModalState, string> = {
  [AuthModalState.SHOW_SIGN_IN]: 'Sign In Dialog Opened',
  [AuthModalState.SHOW_SIGN_UP]: 'Sign Up Dialog Opened',
  [AuthModalState.SHOW_PENDING_VERIFICATION]: 'Pending Verification Dialog Opened',
  [AuthModalState.SHOW_FORGOT_PASSWORD]: 'Forgot Password Dialog Opened',
  [AuthModalState.SHOW_2FA]: '2FA Dialog Opened',
};

export const HIDE_INTERCOM_FOR_PATHNAMES = ['/[userOrOrgId]/card'];
